import React from 'react';
import { observer } from 'mobx-react';
import { Heading1, Heading3 } from '../../design-system/headings';
import { useTranslation } from 'react-i18next';
import DefaultTrans from '../default-i18next-trans';

function PresentationHeading({ ui }) {
    const { t } = useTranslation('assessment');
    return (
        <>
            {ui.pretitle && <Heading3 lighter>{t(ui.pretitle)}</Heading3>}
            {ui.title && <Heading1 mb={8}>{t(ui.title)} </Heading1>}
            {ui.description && (
                <DefaultTrans translatedString={t(ui.description)} />
            )}
        </>
    );
}

export default observer(PresentationHeading);
